import React, { useCallback, useEffect, useState } from 'react';
import AppLayout from './components/AppLayout';
import ItemList from './components/ItemList';
import PageHeader from './components/PageHeader';
import { fetchClassDashboards, fetchUpcomingEvents } from './services/whiteboardApi';
import { mergeClassDashboards } from './utils/classDashboard';
import { getStoredClassTokens } from './utils/classTokens';
import { getStoredBoard, selectedGroupTokens } from './utils/subjectGroups';
import { getLocalDateString } from './utils/date';

function UpcomingEvents() {
    const [events, setEvents] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [classTokens] = useState(() => selectedGroupTokens().length
        ? selectedGroupTokens()
        : getStoredClassTokens());
    const [boardId] = useState(getStoredBoard);

    const name = localStorage.getItem('name');

    const fetchData = useCallback(async () => {
        if (!name && !classTokens.length) {
            setIsLoading(false);
            setErrorMessage('Please open your homework section URL first so we can save your username.');
            return;
        }

        setIsLoading(true);
        setErrorMessage('');

        try {
            const classResult = classTokens.length
                ? await fetchClassDashboards(classTokens, getLocalDateString(), boardId)
                : null;
            const data = classResult
                ? mergeClassDashboards(classResult.dashboards)
                : await fetchUpcomingEvents(name);
            setEvents((classResult ? data.upcoming : data.table) || []);
            if (classResult?.failedCount) {
                setErrorMessage(`${classResult.failedCount} saved class link could not be loaded. The other classes are shown below.`);
            }
        } catch (error) {
            console.error('There was a problem with the POST request:', error);
            setErrorMessage('Unable to load upcoming events right now. Please try again later.');
        } finally {
            setIsLoading(false);
        }
    }, [boardId, classTokens, name]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <AppLayout>
            <div className="mx-auto flex w-full max-w-4xl flex-col">
                <PageHeader
                    title="Upcoming Events"
                    description="Events and reminders from the whiteboard, ordered as provided by the school system."
                />

                {errorMessage && (
                    <div className="mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm font-medium text-red-700">
                        {errorMessage}
                    </div>
                )}

                <ItemList
                    items={events}
                    emptyMessage={isLoading ? 'Loading upcoming events...' : 'No upcoming events found.'}
                    showRecordDate
                />
            </div>
        </AppLayout>
    );
}

export default UpcomingEvents;
